export default "__VITE_ASSET__9c1c35f9__"